import React, { useCallback } from 'react';

import { twMerge } from 'tailwind-merge';

import Typography from 'components/typography/typography';

import Checkbox from 'components/checkbox/checkbox';

import Button from 'components/button/button';

import Divider from 'components/divider/divider';

import Autocomplete from 'components/autocomplete/autocomplete';

import { useAvailableSingleCallJobs } from 'state/context/freelancer/FreelancerAvailableJobs';

import { useGetFreelancerDetails } from 'state/remote/remote-freelancer/use-get-freelancer-details';

import useGetFreelancerCompetences from 'state/remote/remote-freelancer/use-get-freelancer-competences';

import {
  DISTANCE_OPTIONS,
  TYPE_OPTIONS,
} from 'constants/freelancer-ads-all-constants';

import { createLocale } from 'locales';

const localize = createLocale('freelancerAvailableJobsLocales');

const AvailableJobFilterForm: React.FC = () => {
  const {
    handleFilterEnabled,
    distance,
    filterCompetences,
    postCode,
    ifAvailable,
    isNewJob,
    isWholeDay,
    kindOfJob,
    minimumPay,
    organisationName,
    filterEnabled,
    filterInitiated,
    setDistance,
    setIfAvailable,
    setOrganisationName,
    setFilterCompetences,
    setPostCode,
    setIsNewJob,
    setIsWholeDay,
    setKindOfJob,
    setMinimumPay,
    availablejobs,
    organisationSuggestions,
  } = useAvailableSingleCallJobs();

  const competences = useGetFreelancerCompetences();

  const { data: freelancerDetails, competencesArray } =
    useGetFreelancerDetails();

  const freelancerHomeAddress = freelancerDetails?.addresses?.find(
    (address) => address.address_type === 'Home',
  );

  const handleMinRateChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      let val = 0;
      val =
        event.target.value !== '' && Number(event.target.value) >= 0
          ? Number(event.target.value)
          : 0;
      setMinimumPay(val.toString());
    },
    [setMinimumPay],
  );

  const organosationNames = organisationSuggestions?.data.map((item) => ({
    label: item.text,
    value: item.value?.toString() || '',
  }));

  const onAutoCompleteInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) =>
      setOrganisationName({
        text: event.target.value,
        value: Number(event.target.value),
      }),
    [setOrganisationName],
  );

  const onAutoCompleteValueChange = useCallback(
    (value: string) => {
      setOrganisationName({
        text:
          organisationSuggestions?.data?.find(
            (org) => org.value?.toString() === value,
          )?.text || '',
        value: Number(value),
      });
    },
    [organisationSuggestions?.data, setOrganisationName],
  );

  const handleCompetenceChecked = useCallback(
    (item: string) => {
      if (filterCompetences.find((comp) => comp === item)) {
        const filteredList = filterCompetences.filter((comp) => comp !== item);
        setFilterCompetences(filteredList);
      } else {
        setFilterCompetences([...filterCompetences, item]);
      }
    },
    [filterCompetences, setFilterCompetences],
  );

  const travelDistanceSelectClassName = twMerge(
    'w-8/12 h-9 border bg-background border-gray-800',
    'rounded-l-md rounded-r-none pl-5 pr-2 text-body-large',
    'border-slate300',
  );

  const minRateInputClassName = twMerge(
    'col w-full h-9 border',
    'active:outline-none focus:outline-none',
    'bg-background rounded-md pl-5 pr-2',
    'text-body-large border-slate300',
  );

  const autoCompleteInputClassName = twMerge(
    'col w-full h-9 border active:outline-none',
    'focus:outline-none bg-background ',
    'rounded-md text-body-large border-slate300',
  );

  const postCodeInputClassName = twMerge(
    'w-full border h-full active:outline-none',
    'focus:outline-none bg-gray50 rounded-l-none',
    'rounded-r-md pl-3  text-body-large',
    'border-slate300 placeholder-gray500',
  );

  const kindOfassigenmentClassName = twMerge(
    'w-full h-9 border pr-2',
    'bg-background border-gray-800 rounded-md',
    'pl-5 text-body-large border-slate300',
  );

  const filterBtnClassName = twMerge(
    'flex items-center bg-lightBlue',
    'justify-center px-10 hover:bg-darkBlue',
    'disabled:bg-danger hover:text-white text-center',
  );

  const resetBtnClassName = twMerge(
    'flex items-center text-body-medium',
    'justify-center px-10 content-center',
    'hover:bg-gray100 hover:text-white',
  );

  return (
    <div className="container w-full text-purple">
      <div className="container h-fit flex flex-col ml-4 md:ml-0 md:flex-row md:items-center  w-full pr-10 mt-5 mb-4">
        <Typography
          as="h2"
          variant="body-large-bold"
          className="col w-full md:w-2/12 text-start md:text-end mr-5 text-purple"
        >
          {localize('minimumHourlyRate')}
        </Typography>
        <div className="w-full md:w-10/12   md:ml-5 items-start justify-center">
          <input
            value={minimumPay}
            onChange={handleMinRateChange}
            id="min-tarif"
            placeholder={localize('minimumHourlyRate')}
            type="number"
            className={minRateInputClassName}
          />
        </div>
      </div>
      <div className="container flex flex-col ml-4 md:ml-0  md:flex-row md:items-center w-full pr-10 mx-auto mb-4">
        <Typography
          as="h2"
          variant="body-large-bold"
          className="col w-full md:w-2/12 text-start md:text-end mr-10 text-purple"
        >
          {localize('organisation')}
        </Typography>
        <div className="w-full md:w-10/12  items-start justify-center">
          <Autocomplete
            autoCompleteInputClassName={autoCompleteInputClassName}
            OptionsContainerClassName="z-40 max-h-[200px]"
            asynch
            isLoading={organisationSuggestions.isLoading}
            emptyResultMessage={localize('noResultsFound')}
            placeholder={localize('name')}
            defaultOption={
              filterEnabled
                ? {
                    label: organisationName.text,
                    value: organisationName.value?.toString() || '',
                  }
                : null
            }
            onValueChange={onAutoCompleteValueChange}
            options={organosationNames}
            onInputChange={onAutoCompleteInputChange}
          />
        </div>
      </div>

      <div className="container h-fit flex flex-col ml-4 lg:ml-0  md:flex-row md:items-center  w-full pr-10 mx-auto mb-4">
        <Typography
          as="h2"
          variant="body-large-bold"
          className="col w-full md:w-2/12 text-start md:text-end mr-10 text-purple"
        >
          {localize('travelDistance')}
        </Typography>
        <div className="flex flex-row lg:justify-between lg:items-start w-full lg:w-10/12 items-start">
          <select
            id="distance"
            value={distance}
            onChange={(e) => {
              setDistance(e.target.value);
            }}
            aria-label="distance"
            className={travelDistanceSelectClassName}
          >
            {DISTANCE_OPTIONS.map(([values, stringDisplay], index) => (
              <option
                value={values}
                id={index.toString()}
                key={values + Date.now()}
              >
                {stringDisplay}
              </option>
            ))}
          </select>
          <div className="flex flex-row w-4/12 h-9 justify-start lg:justify-end">
            <input
              placeholder={localize('postCode')}
              value={
                postCode !== undefined
                  ? postCode
                  : freelancerHomeAddress?.postal_code || ''
              }
              maxLength={7}
              onChange={(e) => {
                setPostCode(e.target.value);
              }}
              id="postcode"
              type="text"
              className={postCodeInputClassName}
            />
          </div>
        </div>
      </div>
      <div className="container h-fit flex flex-col ml-4 md:ml-0  md:flex-row md:items-center  w-full pr-10 mx-auto mb-4">
        <Typography
          as="h2"
          variant="body-large-bold"
          className="col w-full md:w-2/12 text-start md:text-end mr-10"
        >
          {localize('kindOfAssignment')}
        </Typography>
        <div className="col w-full md:w-10/12 items-start justify-center">
          <select
            value={kindOfJob}
            onChange={(e) => {
              // eslint-disable-next-line
              setKindOfJob((prev) => e.target.value);
            }}
            id="kindOfJob"
            aria-label="ok"
            className={kindOfassigenmentClassName}
          >
            {TYPE_OPTIONS.map(([value, stringDisplay], index) => (
              <option
                value={value}
                id={index.toString()}
                key={value + Date.now()}
              >
                {stringDisplay}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="w-full my-2 flex justify-center items-center">
        <Divider orientation="horizontal" className="w-[90%] mb-1" />
      </div>
      <div className="container flex flex-col ml-4 md:ml-0  md:flex-row md:items-center w-full pr-10 mx-auto mb-4">
        <Typography
          as="h2"
          variant="body-large-bold"
          className="col w-full md:w-2/12 text-start md:text-end mr-10 text-purple"
        >
          {localize('newAssignments')}
        </Typography>
        <div className="col w-full md:w-10/12 items-start justify-center">
          <Checkbox
            variant={isNewJob ? 'checked' : 'unchecked'}
            className="items-start"
            onClick={() => {
              setIsNewJob((prev) => !prev);
            }}
          />
        </div>
      </div>
      <div className="container flex flex-col md:flex-row ml-4 md:ml-0  md:items-center w-full pr-10 mx-auto mb-4">
        <Typography
          as="h2"
          variant="body-large-bold"
          className="col w-full md:w-2/12 text-start md:text-end mr-10 text-purple"
        >
          {localize('wholeDays')}
        </Typography>
        <div className="col w-full md:w-10/12 items-start justify-center">
          <Checkbox
            variant={isWholeDay ? 'checked' : 'unchecked'}
            className="items-start"
            onClick={() => setIsWholeDay((prev) => !prev)}
          />
        </div>
      </div>
      <div className="container flex flex-col md:flex-row ml-4 md:ml-0  md:items-center w-full pr-10 mx-auto mb-4">
        <Typography
          as="h2"
          variant="body-large-bold"
          className="col w-full md:w-2/12 text-start md:text-end mr-10 text-purple"
        >
          {localize('availableOnly')}
        </Typography>
        <div className="col w-full md:w-10/12 items-start justify-center">
          <Checkbox
            variant={ifAvailable ? 'checked' : 'unchecked'}
            className="items-start"
            onClick={() => {
              setIfAvailable((prev) => !prev);
            }}
          />
        </div>
      </div>
      <div className="w-full my-2 flex justify-center items-center">
        <Divider orientation="horizontal" className="w-[90%] mb-1" />
      </div>
      {!!competencesArray?.length && (
        <div className="container flex flex-col ml-4 md:ml-0  md:flex-row md:items-start w-full pr-10 mx-auto mb-4 mt-2">
          <Typography
            as="h2"
            variant="body-large-bold"
            className="col w-full mb-2 md:mb-auto md:w-2/12 text-start md:text-end mr-10 text-purple"
          >
            {localize('competences')}
          </Typography>
          <div className="col w-full md:w-10/12 items-start justify-center">
            <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-3 lg:grid-cols-4 lg:gap:3">
              {competencesArray.map((item) => (
                <div
                  key={item}
                  className="flex flex-row items-center justify-start"
                >
                  <Checkbox
                    id="competence"
                    variant={
                      filterCompetences.find((comp) => comp === item)
                        ? 'checked'
                        : 'unchecked'
                    }
                    value={item}
                    onClick={() => handleCompetenceChecked(item)}
                  />
                  <Typography variant="body-medium" as="h5" className="ml-2">
                    {(competences?.data.length &&
                      competences?.data?.find((comp) => comp.code === item)
                        ?.name) ||
                      ''}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="w-full my-2 flex justify-center items-center">
        <Divider orientation="horizontal" className="w-[90%] md:w-[60%] mb-1" />
      </div>
      <div className="container flex flex-row w-full mx-auto mb-4">
        <div className="flex flex-col w-full md:w-1/2 items-center justify-center">
          <Button
            label={localize('applyFilters')}
            disabled={availablejobs.isLoading}
            onClick={() => {
              handleFilterEnabled(true);
              if (filterInitiated)
                availablejobs.refetch({ throwOnError: true });
            }}
            variant="primary"
            className={filterBtnClassName}
          />
        </div>
        <div className="flex flex-col w-full md:w-1/2 items-center justify-center">
          <Button
            label={localize('allServices')}
            variant="outlined"
            className={resetBtnClassName}
            labelClassName="text-body-medium"
            onClick={() => {
              handleFilterEnabled(false);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AvailableJobFilterForm;
